exports.serviceTeam="hanwha";
exports.serviceType="digest";
exports.authServerHost = `${process.env.REACT_APP_AUTH_API_URL}`;